<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10On44D/tc-custom/9780226925189.jpg?1736613716061" alt="This image is the cover for the book Sea Monsters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sea Monsters
      </h1>
      <p class="bookDescription body article font2">
        <b>The mythic creature expert and author of <i>Phoenix </i>takes readers through a bestiary of sea monsters featured on the famous 16th century map <i>Carta Marina</i>.</b><br/>  <br/> In the sixteenth century, sea serpents, giant man-eating lobsters, and other monsters were thought to swim the waters of Norther Europe, threatening seafarers who ventured too far from shore. Thankfully, Scandinavian mariners had Olaus Magnus, who in 1539 charted these fantastic marine animals in his influential map of the Nordic countries, the <i>Carta Marina</i>. In <i>Sea Monsters</i>, mythologist Joseph Nigg brings readers face-to-face with these creatures and other magnificent components of Magnus’s map.<br/><br/> Nearly two meters wide in total, the map’s nine wood-block panels comprise the largest and first realistic portrayal of the region. But in addition to its important geographic significance, Magnus’s map goes beyond cartography to scenes both domestic and mystic. Close to shore, Magnus shows humans interacting with common sea life—boats struggling to stay afloat, merchants trading, children swimming, and fisherman pulling lines<i>. </i>But from the offshore deeps rise some of the most terrifying sea creatures imaginable—like sea swine, whales as large as islands, and the Kraken. In this book, Nigg draws on Magnus’s own text to further describe and illuminate these inventive scenes and to flesh out the stories of the monsters.<br/><br/><i>Sea Monsters </i>is a stunning tour of a world that still holds many secrets for us land dwellers, who will forever be fascinated by reports of giant squid and the real-life creatures of the deep that have proven to be as bizarre and otherworldly as we have imagined for centuries. It is a gorgeous guide for enthusiasts of maps, monsters, and the mythic.<br/>  <br/><b>“[A] beautiful new exploration of the <i>Carta Marina</i>.”—<i>Wired</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Nigg
      </h2>
      
      <p class="authorDescription body article">Joseph Nigg is also the author of The Book of Fabulous Beasts and How to Raise and Keep a Dragon, among others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?118f0fbe